<template>
  <v-container id="fcreate" fluid>
    <v-row>
      <v-col cols="12">
        <div
          class="text-h3 mb-2"
          v-text="`Создать слайд`"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-form ref="form" v-model="valid">
        <v-container fluid>
          <v-row>
            <!-- Название -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                label="Название"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <v-col cols="12" md="7">
              <regions-select-fields
                v-model="data.regions"
                label="Доступно в регионах"
                empty-text="Доступно во всех регионах"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>

            <v-col cols="12">
              <regions-select-fields
                v-model="data.regionsExclude"
                label="Не доступно в регионах"
                empty-text="Нет исключенных регионов"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>

            <!-- Цвет фона -->
            <v-col cols="12" md="7">
              <v-menu
                v-model="menu"
                nudge-bottom="105"
                nudge-left="16"
                top
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="data.color"
                    v-mask="mask"
                    label="Цвет фона"
                    outlined
                    v-on="on"
                  />
                </template>
                <v-card>
                  <v-card-text class="pa-0">
                    <v-color-picker v-model="data.color" mode="hexa" flat />
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-col>
            <!-- Изображения для десктопа -->
            <v-col
              cols="12"
              md="7"
            >
              <upload-image
                v-model="data.desktopImage"
                color="orange"
                label="Загрузить фото"
              >
                Изображения для десктопа
              </upload-image>
            </v-col>
            <!-- Изображение для мобильных устройств -->
            <v-col
              cols="12"
              md="7"
            >
              <upload-image
                v-model="data.mobileImage"
                color="orange"
                label="Загрузить фото"
              >
                Изображение для мобильных устройств
              </upload-image>
            </v-col>
            <!-- Ссылка -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.link"
                label="Ссылка"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Цель -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.target"
                label="Цель"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Сортировка -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.sortOrder"
                label="Индекс сортировки"
                outlined
                required
                :rules="rules.requiredNumber"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Submit -->
            <v-col cols="12" md="7">
              <v-btn
                class="mb-2"
                block
                color="primary"
                :loading="loading"
                :disabled="loading"
                @click.prevent="submit"
              >
                Создать
              </v-btn>
              <v-btn
                block
                :loading="loading"
                :disabled="loading"
                @click.prevent="$router.push('/slider')"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import rules from '@/mixins/rules'
  import RegionsSelectFields from '@/components/ui/crud/fields/RegionsSelectField'

  export default {
    components: { RegionsSelectFields },
    mixins: [rules],
    data () {
      return {
        data: {
          name: '',
          color: '',
          desktopImage: '',
          mobileImage: '',
          link: '',
          target: 'home',
          sortOrder: 1,
          status: true,
          regions: [],
          regionsExclude: [],
        },
        loading: false,
        valid: false,
        snackbar: false,
        mask: '!#XXXXXXXX',
        menu: false,
      }
    },
    methods: {
      async submit () {
        const validate = await this.$refs.form.validate()

        if (validate) {
          try {
            this.loading = true

            const res = await this.$store.dispatch('slider/createSlider', this.data)
            if (res.status === 200) {
              this.$router.push('/slider')
            }
          } catch (e) { console.log(e) }

          this.loading = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
